export default "__VITE_ASSET__Ca3mbzkH__"